/*! Homepage collection-list carousel: 1 card + 1/3 peek (4/3 visible) */
const MOBILE_MQ = window.matchMedia("(max-width: 47.9275em)");
/** 1 full card + peek of 1/3 card */
const VISIBLE_CARDS = 4 / 3;
const TRACK_SELECTOR = [
  ".template-index .section--collections-list [data-items].grid-layout--1\\@mob",
  "body.template-collection#rooms [data-section-type=\"featured-collections\"] [data-items].grid-layout--1\\@mob",
].join(",");

const MOBILE_NAV_HOST_SELECTOR = [
  "body.template-collection#rooms [data-section-type=\"featured-collections\"] items-scroll-paged-navigation",
  "body.template-collection#collections [data-section-type=\"featured-collections\"] items-scroll-paged-navigation",
].join(",");

function measureTrack(track) {
  const host = track.closest("items-scroll-paged-navigation, items-scroll");

  if (!MOBILE_MQ.matches) {
    track.style.removeProperty("--collection-list-card-width");
    if (host) host.style.removeProperty("--collection-list-card-width");
    return;
  }

  const styles = getComputedStyle(track);
  const gap = Number.parseFloat(styles.columnGap) || 0;
  const padLeft = Number.parseFloat(styles.paddingLeft) || 0;
  // From first card edge to viewport right edge (at scroll 0)
  const visibleWidth = track.clientWidth - padLeft;

  if (visibleWidth <= gap) return;

  const cardWidth = (visibleWidth - gap) / VISIBLE_CARDS;
  track.style.setProperty("--collection-list-card-width", `${cardWidth}px`);
  if (host) host.style.setProperty("--collection-list-card-width", `${cardWidth}px`);
}

/**
 * Mobile prev arrow:
 * - CSS hides prev until host has [data-nav-inited]
 * - On first create, if still at start, set disabled=true then mark inited
 * - After that, theme IntersectionObserver controls enable/disable as usual
 */
function lockPrevAtStart(host) {
  if (!MOBILE_MQ.matches) return false;

  const items = host.querySelector("[data-items]");
  const prev = host.querySelector("[data-navigation-prev]");
  if (!items || !prev) return false;

  if (items.scrollLeft <= 2) {
    prev.disabled = true;
  }
  host.setAttribute("data-nav-inited", "");
  return true;
}

function bindMobileNav(host) {
  if (host.dataset.mobileNavBound) return;
  host.dataset.mobileNavBound = "1";

  const tryLock = () => {
    lockPrevAtStart(host);
  };

  new MutationObserver(tryLock).observe(host, {
    childList: true,
    subtree: true,
  });

  tryLock();
  // Theme observer may briefly clear disabled on cold start; re-lock only while at start.
  [0, 50, 150, 400, 1000].forEach((ms) => {
    setTimeout(() => {
      if (!MOBILE_MQ.matches) return;
      const items = host.querySelector("[data-items]");
      const prev = host.querySelector("[data-navigation-prev]");
      if (!items || !prev) return;
      if (items.scrollLeft <= 2) prev.disabled = true;
      host.setAttribute("data-nav-inited", "");
    }, ms);
  });
}

function bindTrack(track) {
  if (track.dataset.collectionCarouselBound) return;
  track.dataset.collectionCarouselBound = "1";

  const host = track.closest("items-scroll-paged-navigation, items-scroll");

  const scheduleMeasure = () => {
    requestAnimationFrame(() => measureTrack(track));
  };

  const resizeObserver = new ResizeObserver(scheduleMeasure);
  resizeObserver.observe(track);
  if (host) resizeObserver.observe(host);

  if (host) {
    new MutationObserver(scheduleMeasure).observe(host, {
      attributes: true,
      attributeFilter: ["scroll-enabled"],
    });
  }

  scheduleMeasure();
  setTimeout(scheduleMeasure, 0);
  setTimeout(scheduleMeasure, 150);
  setTimeout(scheduleMeasure, 500);
}

function scanTracks() {
  document.querySelectorAll(TRACK_SELECTOR).forEach(bindTrack);
}

function scanMobileNav() {
  document.querySelectorAll(MOBILE_NAV_HOST_SELECTOR).forEach(bindMobileNav);
}

function initCollectionListCarousel() {
  scanTracks();
  scanMobileNav();

  MOBILE_MQ.addEventListener("change", () => {
    document.querySelectorAll(TRACK_SELECTOR).forEach(measureTrack);
  });

  new MutationObserver(() => {
    scanTracks();
    scanMobileNav();
  }).observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCollectionListCarousel);
} else {
  initCollectionListCarousel();
}
